import Quiz from "@material-symbols/svg-500/rounded/quiz.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

const DiagnosticIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Quiz });
	return <Icon />;
};

export default memo(DiagnosticIcon);
